export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9163.a7f54365.jpg";